import {
  CreditCard,
  Wallet,
  Smartphone,
  ArrowLeftRight,
  Zap,
  Banknote,
  QrCode,
  Phone,
  MoreHorizontal,
  type LucideIcon,
} from 'lucide-react';

/**
 * Maps payment method icon names (from PaymentMethodDefinition.icon)
 * to Lucide React components — same pattern as CategoryIcon's IONICON_TO_LUCIDE.
 */
const ICON_MAP: Record<string, LucideIcon> = {
  'credit-card': CreditCard,
  'wallet': Wallet,
  'smartphone': Smartphone,
  'arrow-left-right': ArrowLeftRight,
  'zap': Zap,
  'banknote': Banknote,
  'qr-code': QrCode,
  'phone': Phone,
  'more-horizontal': MoreHorizontal,
};

export function getPaymentMethodIcon(iconName: string): LucideIcon {
  return ICON_MAP[iconName] ?? CreditCard;
}
